module.exports = __webpack_public_path__ + "img/operate_list5.7c7f6c20.png";